import { simularPrecoAtualCarrinho, isPedidoDoacao } from '@/utils/impostoSimulador';

// Shared across page changes: four fiscal jobs at most, never the full catalog.
const pending = new Map();
const cache = new Map();
const queue = [];
let active = 0;
function drain() {
  while (active < 4 && queue.length) {
    const job = queue.shift();
    active += 1;
    Promise.resolve().then(job.run).then(job.resolve, job.reject).finally(() => {
      active -= 1;
      drain();
    });
  }
}
export function cotarProdutoCatalogo(contexto, form, itemId, vigente = () => true) {
  const key = JSON.stringify([contexto, itemId]);
  const cached = cache.get(key);
  if (cached && Date.now() - cached.at < 60000) return Promise.resolve(cached.value);
  if (pending.has(key)) return pending.get(key).then(value => (
    value === null && vigente() ? cotarProdutoCatalogo(contexto, form, itemId, vigente) : value
  ));
  const promise = new Promise((resolve, reject) => {
    queue.push({ resolve, reject, run: async () => {
      if (!vigente()) return null;
      const quote = await simularPrecoAtualCarrinho(form, itemId);
      const value = isPedidoDoacao(form) ? quote.preco : quote.tabela;
      if (!Number.isFinite(value) || value <= 0) throw new Error('Preço indisponível');
      if (cache.size >= 240) cache.delete(cache.keys().next().value);
      cache.set(key, { at: Date.now(), value });
      return value;
    } });
    drain();
  }).finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}